export default {
    name: "compare_date",
    definition: {
        init: function () {
            this.jsonInit({
                "message0": 'Date %1is %2 %3',
                "args0": [
                    {
                        "type": "input_value",
                        "name": "DATE1"
                    },
                    {
                        "type": "field_dropdown",
                        "name": "COMPARISON",
                        "options": [
                            ["before", "BEFORE"],
                            ["after", "AFTER"],
                            ["same as", "EQUAL"]
                        ]
                    },
                    {
                        "type": "input_value",
                        "name": "DATE2"
                    }
                ],
                "inputsInline": true,
                "output": "Boolean",
                "colour": 4.5,
                "tooltip": "Compares two dates",
                "helpUrl": "http://www.w3schools.com/jsref/jsref_length_string.asp"
            });
        }
    },
    codeGenerator: (blocklyInstance) => function (block) {
        const compares = {
            "AFTER": (date1, date2) => `${date1}.isAfter(${date2})`,
            "BEFORE": (date1, date2) => `${date1}.isBefore(${date2})`,
            "EQUAL": (date1, date2) => `${date1}.isEqual(${date2})`
        }

        const date1 = blocklyInstance.JavaScript.valueToCode(block, "DATE1", blocklyInstance.JavaScript.ORDER_ATOMIC);
        const date2 = blocklyInstance.JavaScript.valueToCode(block, "DATE2", blocklyInstance.JavaScript.ORDER_ATOMIC);
        const compare = block.getFieldValue("COMPARISON");

        return [compares[compare](date1, date2), blocklyInstance.JavaScript.ORDER_NONE];
    }
}